import { useContext, useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import AlertContext, { AlertOnHide, AlertType } from '../../../context/alertContext';
import { useHandleLogoutAfterIdleTime } from '../../../hooks/useHandleLogout';
import { Paths } from '../../../Routes';
import { resetShowAlertMessage } from '../../../utils/alertHandling';
import StyledButton from '../../Buttons/StyledButton';
import { StyledModal } from '../StyledModal/StyledModal';

const AlertModal = () => {
    const navigate = useNavigate();
    const { alertstate, alertdispatch } = useContext(AlertContext);
    const { handleLogoutAfterIdleTime } = useHandleLogoutAfterIdleTime();
    const [errorType, setErrorType] = useState('info');

    useEffect(() => {
        if (alertstate.alertMessage.alertType !== undefined) {
            if (alertstate.alertMessage.alertType === AlertType.info) {
                setErrorType('info');
            } else if (alertstate.alertMessage.alertType === AlertType.error) {
                setErrorType('danger');
            } else {
                setErrorType('info');
            }
        }
    }, [alertstate.alertMessage]);

    const onHideHandling = () => {
        resetShowAlertMessage(alertdispatch);

        if (
            alertstate.alertMessage.onHide === AlertOnHide.custom &&
            alertstate.alertMessage.onHideCustom !== undefined
        ) {
            alertstate.alertMessage.onHideCustom();
        } else {
            if (alertstate.alertMessage.onHide === AlertOnHide.onlyClose) {
                // do nothing
            } else {
                handleLogoutAfterIdleTime();

                if (alertstate.alertMessage.onHide === AlertOnHide.goToHome) {
                    navigate(Paths.HOME);
                } else {
                    navigate(Paths.HOME);
                }
            }
        }
    };

    return (
        <StyledModal
            show={alertstate.alertMessage.showModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">{alertstate.alertMessage.alertTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant={errorType}>
                    <p>{alertstate.alertMessage.alertTxt}</p>
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <StyledButton onClick={onHideHandling}>OK</StyledButton>
            </Modal.Footer>
        </StyledModal>
    );
};

export default AlertModal;
